import React, { useCallback } from "react";
import { ValidatedInput, EventButton } from "../common";
import { useFormValidation } from "../../../hooks/newyear";
import { maskPhoneInput, unmaskPhone } from "../../../utils/newyear/masks";

const WinnerInfoForm = ({
  initialValues = {},
  onSubmit,
  loading = false,
  submitLabel = "제출하기",
  disabled = false,
  remainingModifications,
}) => {
  const {
    values,
    handleChange,
    handleBlur,
    validate,
    getFieldError,
    isValid,
  } = useFormValidation({
    name: initialValues.name || "",
    phone: initialValues.phone || "",
  });

  const handlePhoneChange = useCallback(
    (e) => {
      const masked = maskPhoneInput(e.target.value);
      handleChange("phone")({ target: { value: masked } });
    },
    [handleChange]
  );

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();

      if (!validate()) return;

      const cleanPhone = unmaskPhone(values.phone);
      onSubmit({
        name: values.name.trim(),
        phone: cleanPhone,
      });
    },
    [values, validate, onSubmit]
  );

  return (
    <form className="newyear-winner-form" onSubmit={handleSubmit}>
      <div className="newyear-winner-form__fields">
        <ValidatedInput
          label="이름"
          type="text"
          value={values.name}
          onChange={handleChange("name")}
          onBlur={handleBlur("name")}
          placeholder="실명을 입력해주세요"
          maxLength={20}
          error={getFieldError("name")}
          required
          disabled={disabled}
        />

        <ValidatedInput
          label="연락처"
          type="tel"
          value={values.phone}
          onChange={handlePhoneChange}
          onBlur={handleBlur("phone")}
          placeholder="010-0000-0000"
          maxLength={13}
          error={getFieldError("phone")}
          required
          disabled={disabled}
        />
      </div>

      {remainingModifications !== undefined && (
        <p className="newyear-winner-form__modifications">
          남은 수정 횟수: {remainingModifications}회
        </p>
      )}

      <div className="newyear-winner-form__notice">
        <p>* 정확한 정보를 입력해주세요.</p>
        <p>* 잘못된 정보 입력 시 경품 수령이 불가할 수 있습니다.</p>
      </div>

      <div className="newyear-winner-form__actions">
        <EventButton
          type="submit"
          variant="primary"
          size="large"
          fullWidth
          loading={loading}
          disabled={disabled || !isValid}
        >
          {submitLabel}
        </EventButton>
      </div>
    </form>
  );
};

export default WinnerInfoForm;
